import { IconUserPlus } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

interface ProfileSelectorEmptyProps {
  onClose?: () => void;
}

export function ProfileSelectorEmpty({ onClose }: ProfileSelectorEmptyProps) {
  return (
    <div className="px-3 py-4 text-center">
      <IconUserPlus size={32} className="text-secondary mb-2" />
      <p className="text-secondary mb-2 small">Nie masz jeszcze żadnych profili</p>
      <Link to="/profiles/add" className="btn btn-primary btn-sm" onClick={onClose}>
        Utwórz pierwszy profil
      </Link>
    </div>
  );
}
